<template>
  <card :title="computedTitle" :on-cancel="cancel">
    <Form ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveProject)">
        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="keyInput"
              ref="keyInput"
              v-model="key"
              :name="'key'"
              variant="static"
              :label="$t('projects.key') + ' *'"
              :placeholder="$t('projects.key')"
            />
          </div>
          <div class="col-md-4">
            <label class="col-md-4 col-form-label">{{$t('common.status')}} *</label>
            <el-select
              ref="projectStatusInput"
              v-model="selectedOption"
              :class="selectClass"
              size="medium"
              style="width: 100%;"
              :placeholder="$t('common.status')"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.id"
                :class="selectClass"
                :value="item.status"
                :label="item.status"
              />
            </el-select>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="nameInput"
              v-model="name"
              :name="'name'"
              variant="static"
              :label="$t('common.name') + ' *'"
              :placeholder="$t('common.name')"
            />
          </div>
          <div class="col-md-4">
            <material-input-field
              id="descriptionInput"
              v-model="description"
              :name="'description'"
              variant="static"
              :label="$t('common.description')"
              :placeholder="$t('common.description')"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <material-input-field
              id="addressInput"
              v-model="address"
              :name="'address'"
              variant="static"
              :label="$t('projects.address')"
              :placeholder="$t('projects.address')"
            />
          </div>
          <div class="col-md-4">
            <material-input-field
              id="zipCodeInput"
              v-model="zipCode"
              :name="'zipCode'"
              variant="static"
              :label="$t('projects.zipCode')"
              :placeholder="$t('projects.zipCode')"
            />
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-md-12">
            <material-checkbox v-model="useDates" @change="onUseDatesChange">
              {{$t('projects.useDates')}}
            </material-checkbox>
          </div>
        </div>

        <hr v-if="useDates">

        <div v-if="useDates" class="row">
          <div class="col-md-4">
            <label class="col-md-4 col-form-label">{{$t('projectAssignments.starts')}}</label>
            <el-date-picker 
              v-model="startDate" 
              :placeholder="$t('projectAssignments.starts')"
              style="width: 100%;"
            />
          </div>
          <div class="col-md-4">
            <label class="col-md-4 col-form-label">{{$t('projectAssignments.ends')}}</label>
            <el-date-picker 
              v-model="endDate" 
              :placeholder="$t('projectAssignments.ends')"
              style="width: 100%;"
            />
          </div>
        </div> -->

        <div v-if="forceEndCustomerSelection" class="row">
          <div class="col-md-4">
            <label class="col-form-label">{{$t('endCustomers.endCustomer')}}</label>
            <div class="d-flex align-items-center">
              <material-input-field
                id="endCustomerInput"
                :model-value="selectedEndCustomerName || '-'"
                :name="'endCustomer'"
                variant="static"
                disabled
                class="flex-grow-1"
              />
              <material-button type="button" variant="gradient" color="dark" size="sm" class="ms-2 mb-3" @click="openEndCustomerModal">
                <i class="material-icons-round">edit</i>
              </material-button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <material-button variant="gradient" color="dark" :disabled="saving" @click="saveProject">
              <span v-if="saving" class="spinner-border spinner-border-sm me-1"></span>
              {{$t('common.submit')}}
            </material-button>
          </div>
        </div>
      </form>
    </Form>

    <!-- End Customer Pick Modal -->
    <el-dialog v-model="showEndCustomerModal" :title="$t('endCustomers.pickEndCustomer')" width="600px">
      <div class="mb-3">
        <el-input
          v-model="endCustomerSearchQuery"
          class="search-input"
          clearable
          :prefix-icon="Search"
          :placeholder="$t('common.searchRecords')"
          @keyup="searchEndCustomers"
          @clear="fetchEndCustomers"
        />
      </div>
      <div style="max-height: 400px; overflow-y: auto;">
        <table class="table">
          <thead>
            <tr>
              <th></th>
              <th>{{$t('common.name')}}</th>
              <th>{{$t('endCustomers.identificationNumber')}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ec in endCustomers" :key="ec.id" style="cursor: pointer;" @click="selectedEndCustomerRadio = ec.id">
              <td><el-radio v-model="selectedEndCustomerRadio" :value="ec.id">&nbsp;</el-radio></td>
              <td>{{ ec.name }}</td>
              <td>{{ ec.identificationNumber }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <el-pagination
          v-model:current-page="endCustomerPagination.currentPage"
          :page-size="endCustomerPagination.perPage"
          :total="endCustomerPagination.total"
          layout="prev, pager, next"
          @current-change="fetchEndCustomers"
        />
      </div>
      <template #footer>
        <material-button variant="gradient" color="dark" @click="confirmEndCustomer">
          {{$t('common.submit')}}
        </material-button>
      </template>
    </el-dialog>
  </card>
</template>
<script>
import api from "../../services/api"
import { ElSelect, ElOption, ElDialog, ElInput, ElRadio, ElPagination } from 'element-plus';
import { Search } from '@element-plus/icons-vue';
import { shallowRef } from 'vue';
import { Form } from 'vee-validate';
import Card from "../../components/Card.vue";
import MaterialInputField from "@/components/MaterialInputField.vue";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  components: {
    ElSelect,
    ElOption,
    ElDialog,
    ElInput,
    ElRadio,
    ElPagination,
    Form,
    Card,
    MaterialInputField,
    MaterialButton
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    },
    keyProp: {
      type: String,
      required: false,
      default: ''
    },
    nameProp: {
      type: String,
      required: false,
      default: ''
    },
    descriptionProp: {
      type: String,
      required: false,
      default: ''
    },
    editingProjectId: {
      type: String,
      required: false,
      default: null
    },
    selectedProjectStatusOptionProp: {
      type: String,
      required: false,
      default: null
    },
    endDateProp: {
      type: String,
      required: false,
      default: null
    },
    startDateProp: {
      type: String,
      required: false,
      default: null
    },
    endCustomerIdProp: {
      type: Number,
      required: false,
      default: null
    },
    endCustomerNameProp: {
      type: String,
      required: false,
      default: null
    },
    forceEndCustomerSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    addressProp: {
      type: String,
      required: false,
      default: ''
    },
    zipCodeProp: {
      type: String,
      required: false,
      default: ''
    }
  },
  emits: ['close', 'refresh-data'],
  data() {
    return {
      Search: shallowRef(Search),
      selectedOption: this.selectedProjectStatusOptionProp,
      description: this.descriptionProp,
      name: this.nameProp,
      key: this.keyProp,
      address: this.addressProp,
      zipCode: this.zipCodeProp,
      saving: false,
      useDates: false,
      startDate: this.startDateProp,
      endDate: this.endDateProp,
      statusOptions:[
        {id: 1, status: this.$t('projectStatus.notStarted') },
        {id: 2, status: this.$t('projectStatus.active') },
        {id: 3, status: this.$t('projectStatus.onHold') },
        {id: 4, status: this.$t('projectStatus.finished') },
      ],
      // End customer
      selectedEndCustomerId: this.endCustomerIdProp,
      selectedEndCustomerName: this.endCustomerNameProp,
      showEndCustomerModal: false,
      endCustomers: [],
      endCustomerSearchQuery: '',
      endCustomerPagination: {
        currentPage: 1,
        perPage: 10,
        total: 0
      },
      selectedEndCustomerRadio: null,
    };
  },
  computed: {
    computedTitle() {
      return this.editMode ? this.$t('projects.editProject') : this.$t('projects.createProject');
    },
    selectClass() {
      let darkMode = localStorage.getItem('darkMode');
      if (darkMode === null) {
        darkMode = 'false';
      }
      if (darkMode === 'false') {
        return 'select-standard';
      } else {
        return 'select-primary';
      }
    }
  },
  created() {
    if(this.endDate !== null && this.startDate !== null)
    {
      this.useDates = true
    }
  },
  methods: {
    onUseDatesChange()
    {
      if(this.useDates === false){
        this.startDate = null
        this.endDate = null
      }
    },
    cancel()
    {
      this.$emit('close');
    },
    async saveProject() {
      if (this.saving) return;
      if (this.validateInput()) {
        if(this.name === ''){
          this.name = null
        }
        if(this.description === ''){
          this.description = null
        }

        this.saving = true;
        try {
          if(this.editMode)
          {
            await api.put('/Project/' + this.editingProjectId, {
              key: this.key,
              name: this.name,
              description: this.description,
              startTime: this.startDate !== null ? this.normalizeDateString(this.startDate): null,
              endTime: this.endDate !== null ? this.normalizeDateString(this.endDate).replace(/T\d{2}:\d{2}:\d{2}/, "T23:59:59"): null,
              projectStatusId: this.statusOptions.filter(op => op.status === this.selectedOption)[0].id,
              endCustomerId: this.selectedEndCustomerId,
              address: this.address || null,
              zipCode: this.zipCode || null
            });
            this.$toast.success(this.$t('projects.projectUpdated'), { timeout: 1500 });
            this.$emit('refresh-data');
            this.$emit('close');
          }
          else
          {
            await api.post('/Project', {
              key: this.key,
              name: this.name,
              description: this.description,
              startTime: this.startDate !== null ? this.normalizeDateString(this.startDate): null,
              endTime: this.endDate !== null ? this.normalizeDateString(this.endDate).replace(/T\d{2}:\d{2}:\d{2}/, "T23:59:59"): null,
              projectStatusId: this.statusOptions.filter(op => op.status === this.selectedOption)[0].id,
              endCustomerId: this.selectedEndCustomerId,
              address: this.address || null,
              zipCode: this.zipCode || null
            });
            this.$toast.success(this.$t('projects.projectCreated'), { timeout: 1500 });
            this.$emit('refresh-data');
            this.$emit('close');
          }
        } catch (error) {
          console.error(error) // eslint-disable-line no-console
          this.$toast.danger(`Unable to create project: ${error.message}`, { timeout: 0 });
        } finally {
          this.saving = false;
        }
      }
    },
    normalizeDateString(dateString) {
      let date = new Date(dateString);
      return date.toISOString();
    },
    openEndCustomerModal() {
      this.showEndCustomerModal = true;
      this.endCustomerSearchQuery = '';
      this.selectedEndCustomerRadio = this.selectedEndCustomerId;
      this.endCustomerPagination.currentPage = 1;
      this.fetchEndCustomers();
    },
    fetchEndCustomers() {
      let url = `/EndCustomer?currentPage=${this.endCustomerPagination.currentPage}&pageSize=${this.endCustomerPagination.perPage}`;
      if (this.endCustomerSearchQuery !== '') {
        url += `&name=${this.endCustomerSearchQuery}`;
      }
      api.get(url)
        .then(response => {
          this.endCustomerPagination.total = response.data.totalItems;
          this.endCustomers = response.data.result.map(item => ({
            id: item.id,
            name: item.name,
            identificationNumber: item.identificationNumber,
          }));
        })
        .catch(error => {
          console.error('API request error:', error); // eslint-disable-line no-console
        });
    },
    searchEndCustomers(event) {
      this.endCustomerPagination.currentPage = 1;
      const queryLength = this.endCustomerSearchQuery.length;
      if (event.key === 'Backspace' || event.key === 'Enter') {
        this.fetchEndCustomers();
      } else if (queryLength > 1 && queryLength % 2 === 0) {
        this.fetchEndCustomers();
      }
    },
    confirmEndCustomer() {
      if (!this.selectedEndCustomerRadio) {
        this.$toast.info(this.$t('endCustomers.pleaseSelectEndCustomer'), { timeout: 2500 });
        return;
      }
      const selected = this.endCustomers.find(ec => ec.id === this.selectedEndCustomerRadio);
      if (selected) {
        this.selectedEndCustomerId = selected.id;
        this.selectedEndCustomerName = selected.name;
      }
      this.showEndCustomerModal = false;
    },
    validateInput() {
      let success = true;
      if (this.key === '') {
        this.$toast.info(this.$t('errors.keyEmpty'), { timeout: 2500 });
        success = false;
      }

      if (this.name === '') {
        this.$toast.info(this.$t('errors.nameEmpty'), { timeout: 2500 });
        success = false;
      }
      if (this.endDate !== null && this.startDate !== null && new Date(this.startDate) > new Date(this.endDate)) {
        this.$toast.info(this.$t('errors.startDateBiggerThanEndDate'), { timeout: 2500 });
        success = false;
      }
      if (this.forceEndCustomerSelection && !this.editMode && !this.selectedEndCustomerId) {
        this.$toast.info(this.$t('endCustomers.pleaseSelectEndCustomer'), { timeout: 2500 });
        success = false;
      }
      return success;
    }
  }
};
</script>
<style></style>
